import ViewMessageList from './ViewMessageList';
import EditMessageList from "./EditMessageList";
import ListMessageLists  from "./ListMessageLists";
 
window.Vue.component('PartnerListMessageLists', ListMessageLists);
window.Vue.component('PartnerViewMessageList', ViewMessageList);
window.Vue.component('PartnerEditMessageList', EditMessageList);
